import { SocialMedia } from '../metadata/social-media.model';
import { OrganizationReach } from '../organization/organization-reach.model';
import { OrganizationImpactType } from '../organization/organization-impact-type.model';
import { OrganizationProvince } from '../organization/organization-province.model';
import { OrganizationHeritageType } from '../organization/organization-heritage-type.model';
import { OrganizationGoal } from '../organization/organization-goal.model';

export class OrganizationDetails {
  public name: string;
  public scope: OrganizationReach;
  public impactTypes: OrganizationImpactType[] = [];
  public provinces: OrganizationProvince[] = [];
  public heritageTypes: OrganizationHeritageType[] = [];
  public heritageGoals: OrganizationGoal[] = [];
  public website: string;
  public email: string;
  public phoneNumber: string;
  // Location
  public address: string;
  public lng: string;
  public lat: string;
  // Contact person
  public contactName: string;
  public contactFunction: string;
  public contactEmail: string;
  // Metadata
  public socialMedia: SocialMedia[] = [];

  constructor(data: any = {}) {
    this.name = data?.name ?? '';
    this.scope = data?.scope ?? new OrganizationReach();
    this.impactTypes = data?.impactTypes ?? [];
    this.provinces = data?.provinces ?? [];
    this.heritageTypes = data?.heritageTypes ?? [];
    this.heritageGoals = data?.heritageGoals ?? [];
    this.website = data?.website ?? '';
    this.email = data?.email ?? '';
    this.phoneNumber = data?.phoneNumber ?? '';
    // Location
    this.address = data?.address ?? '';
    this.lng = data?.lng ?? '0';
    this.lat = data?.lat ?? '0';
    // Contact person
    this.contactName = data?.contactName ?? '';
    this.contactFunction = data?.contactFunction ?? '';
    this.contactEmail = data?.contactEmail ?? '';
    // Metadata
    this.socialMedia = data?.socialMedia ?? [];
  }

  public static createFromApi(data: any = {}): OrganizationDetails {
    const scope: OrganizationReach = OrganizationReach.createFromApi(data?.scope ?? data?.organizationReach);
    const impactTypes: OrganizationImpactType[] = (data?.impactTypes ?? []).map((impactTypeData: any) => OrganizationImpactType.createFromApi(impactTypeData));
    const provinces: OrganizationProvince[] = (data?.provinces ?? []).map((provinceData: any) => OrganizationProvince.createFromApi(provinceData));
    const heritageTypes: OrganizationHeritageType[] = (data?.heritageTypes ?? []).map((heritageData: any) => OrganizationHeritageType.createFromApi(heritageData));
    const heritageGoals: OrganizationGoal[] = (data?.heritageGoals ?? []).map((goalData: any) => OrganizationGoal.createFromApi(goalData));
    const socialMedia: SocialMedia[] = (data?.socialMedia ?? []).map((socialMediaData: any) => SocialMedia.createFromApi(socialMediaData));

    return new OrganizationDetails({
      name: data?.name ?? '',
      scope,
      impactTypes,
      provinces,
      heritageTypes,
      heritageGoals,
      website: data?.website ?? '',
      email: data?.email ?? '',
      phoneNumber: data?.phoneNumber ?? '',
      // Location
      address: data?.address ?? data?.location ?? '',
      lng: data?.lng ?? data?.longitude ?? '0',
      lat: data?.lat ?? data?.latitude ?? '0',
      // Contact person
      contactName: data?.contactName ?? '',
      contactFunction: data?.contactFunction ?? '',
      contactEmail: data?.contactEmail ?? '',
      // Metadata
      socialMedia,
    });
  }

  public processForApi(): Record<string, any> {
    return {
      name: this.name,
      scope: this.scope && this.scope.id ? this.scope.processForApi() : null,
      impactTypes: this.impactTypes.map(impactType => impactType.processForApi()),
      provinces: this.provinces.map(province => province.processForApi()),
      heritageTypes: this.heritageTypes.map(heritageType => heritageType.processForApi()),
      heritageGoals: this.heritageGoals.map(goal => goal.processForApi()),
      website: this.website,
      email: this.email,
      phoneNumber: this.phoneNumber,
      address: this.address,
      lng: this.lng,
      lat: this.lat,
      contactName: this.contactName,
      contactFunction: this.contactFunction,
      contactEmail: this.contactEmail,
      socialMedia: this.socialMedia.map(socialMedia => socialMedia.processForApi()),
    };
  }
}
